export const environment = {
  production: true,
  //apiBaseURL: 'https://bdmi.ine.cv/mdc-api/api',
  apiBaseURL: 'https://mapeamento.gov.cv/mdc-api/api',
  ipApiURL: 'https://ipapi.co/json/',
  mdcLink: 'https://ine.cv/mapeamento',
  publicKeyPem: `-----BEGIN PUBLIC KEY----- MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhg7zlm2sHRj/BFXfcXcQ 2CZTBaLWKe9utiQQ2C19bg69pe2v5Kn5Sbv/1mu4FE3Vf3b04dOyg4NwbPQ5VYVc 7OKCh5c1f1CHCcS6OOyz/BdR16cjPFvekK69RV+RfhSdgs1NV4r6PnmlAZuEfAjc BbOIG3x3vj7eG99fGXe8p5rRcoV0VcrvyW+o8ONw2qzFdJj2bZl57jYtrpACl/EO Wwu5y3Rmxarw9mO66xYu6tX8volWJNBoAzY1LbpCnSaefWtrIj6lV6jM/3amKEG1 vUwVLr+N6sxhQ0tIAfdIvRjuGsc12lVyyrbKN4gBwVxT6ncJiPhAreRAEIZ7x6UL OwIDAQAB -----END PUBLIC KEY-----`
};
